export default function flyoutCart(state = null, action) {
  switch (action.type) {
    case 'RECEIVE_SHOWING_FLYOUT_CART': {
      return { ...state, showing: action.payload }
    }

    default:
      return state
  }
}
